// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"015082a4","339":"178a4d0b","453":"969a3abe","594":"2d255247","820":"e934d681"}[chunkId] + ".chunk.js";
};